import React, { Component } from "react";
import { Router, Switch, Route } from "react-router-dom";
import history from "./history";
import HomeScreen from "./screens/Home";
import ProductScreen from "./screens/Product";
import ProductItemScreen from "./screens/ProductItem";

export default class Routes extends Component {
  render() {
    return (
      <Router history={history}>
        <Switch>
          <Route path="/" exact component={HomeScreen} />
          <Route path="/product" component={ProductScreen} />
          <Route path="/product-item" component={ProductItemScreen} />
        </Switch>
      </Router>
    );
  }
}
